import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a268bdc38ca120014dd427d_1785391562788_bf84037e/wms_pro/src/app/order-management/page.tsx");
